import React from "react";

function App() {
  return (
    <div>
      <h1>CloudPass Manager</h1>
      <p>Your secure password manager</p>
    </div>
  );
}

export default App;
